import React from 'react';

import { FieldTableHeader } from 'components/_basic/Form/FieldTable2/components/FieldTableHeader';
import { FieldTableTotalRow } from 'components/_basic/Form/FieldTable2/components/FieldTableTotalRow';
import { FieldTableContainer } from 'components/_basic/Form/FieldTableContainer';

import { IPersonalExpansesTableProps } from './types';
import { PersonalExpensesTableRow } from '../PersonalExpensesTableRow';

export const PersonalExpansesTable: React.FC<IPersonalExpansesTableProps> = ({
  name,
  headerName = '',
  totalName = '',
  columnsNames,
  rows,
  watchRowTitleName,
  firstColumnWidth = 250,
  disabled = false,
  showSumRow = false,
  editableColumn = true,
  totalRowTitle = '',
  readOnly = false,
  updateRow,
}) => {
  return (
    <FieldTableContainer overflow={false}>
      <FieldTableHeader
        name={headerName}
        disabled={disabled}
        columnsNames={columnsNames}
        firstColumnWidth={firstColumnWidth}
        editableColumn={editableColumn}
        titleColumnGap={1}
      />

      {rows.map((_, index) => (
        <PersonalExpensesTableRow
          key={index === 0 ? rows[1].id : index === 1 ? rows[0].id  : rows[index].id}
          name={name}
          rowIndex={index === 0 ? 1 : index === 1 ? 0 : index}
          columnsNames={columnsNames}
          watchRowTitleName={watchRowTitleName}
          firstColumnWidth={firstColumnWidth}
          disabled={disabled}
          readOnly={readOnly}
          allowToEditFieldsIndexes={[0]}
          updateRow={updateRow}
          values={index === 0 ? rows[1] : index === 1 ? rows[0]  : rows[index] }
        />
      ))}

      {showSumRow && totalName && (
        <FieldTableTotalRow
          totalName={totalName}
          columns={columnsNames}
          disabled={disabled}
          firstColumnWidth={firstColumnWidth}
          totalRowTitle={totalRowTitle}
          titleColumnGap={1}
        />
      )}
    </FieldTableContainer>
  );
};
